module.exports = __webpack_public_path__ + "1bb6a82ecdd6ac0acd4b904f7451db75.svg";


//////////////////
// WEBPACK FOOTER
// ./client/components/TopMenu/icons/menu_icon.svg
// module id = 1560
// module chunks = 0